import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';
import { getUserAccessTokenCookie } from 'commons/localStorage';
import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
import withApolloClient from 'components/hoc/withApolloClient';
import TrackOrderStatusForm from './form';
import TrackOrderStatusView from './view';
const GET_ORDER_TRACKING_WITH_ZIP = gql`
  query getOrderTrackingWithZip(
    $order_id: Int!
    $zip: SanitizedZipCodeInputString!
  ) {
    getOrderTrackingWithZip(order_id: $order_id, zip: $zip) {
      errors {
        code
        message
        field
      }
      order_id
      order_date
      rdc_city
      rdc_state
      display_ship_date
      display_arriving_date
      display_delivery_date
      carrier
      progress
      progress
      mainTitle
      displayDeliveryRange
      payment_type
      order {
        order_id
        order_type
        order_note
        order_status
        order_paynow
        payment_status
        delivery_date
        total_order_amount
        shipment_status
        shipping {
          address_name
          address_first_name
          address_last_name
          address_street1
          address_street2
          address_city
          address_country
          address_state
          address_zip_code
          address_phone
          address_fax
        }
        order_items {
          product_id
          pickLater
          product_type
          quantity
          quantity
          name
          total_cost
          variants_sku
          variants_text
          upholstery
          wood_stain
          option_value_ids
          goal_date
          eta_delivery_start
          eta_delivery_end
          eta_delivery_all
          shipping_status
          tracking_url
          tracking_note
          tracking_number
          carrier
          shipped_date_f
          small_image
          url_key
          sizes_text
          shipping_group
          delivery_method
          estimated_shipping
          shipped_date
          stock_discount
          estimated_delivery
          estimated_delivery_title
          options {
            id
            image
            name
            value
            optionTypeId
            optionTypeName
            default_value
            additional_cost
          }
          applied_protection_plan {
            plan_id
            plan_name
            plan_price
            plan_percent
            plan_description
          }
          available_protection_plans {
            plan_id
            plan_name
            plan_price
            plan_percent
            plan_description
          }
        }
      }
    }
  }
`;
const TrackOrderStatus = props => {
  const $ = _c(32);
  const [setMode] = useState("form");
  const [isLoading, setIsLoading] = useState(false);
  const [setErrMsg] = useState("");
  let t0;
  if ($[0] !== isLoading || $[1] !== props.location.state) {
    t0 = () => {
      let tracking_info;
      if (props.location.state && props.location.state.tracking_info) {
        tracking_info = props.location.state.tracking_info;
      } else {
        tracking_info = null;
      }
      const theObj = {
        isLoading,
        tracking_info
      };
      return theObj;
    };
    $[0] = isLoading;
    $[1] = props.location.state;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const state = t0;
  let t1;
  if ($[3] !== props.history || $[4] !== props.location.pathname || $[5] !== setMode || $[6] !== state) {
    t1 = () => {
      if (props.location.pathname === "/order-tracking/view/") {
        setMode("view");
      } else {
        setMode("form");
        const stateCopy = {
          ...state
        };
        delete stateCopy.tracking_info;
        props.history.replace({
          ...props.history.location,
          stateCopy
        });
      }
    };
    $[3] = props.history;
    $[4] = props.location.pathname;
    $[5] = setMode;
    $[6] = state;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== props.history || $[9] !== props.location.pathname || $[10] !== props.location.state || $[11] !== setMode || $[12] !== state) {
    t2 = [props.history, props.location.pathname, props.location.state, setMode, state];
    $[8] = props.history;
    $[9] = props.location.pathname;
    $[10] = props.location.state;
    $[11] = setMode;
    $[12] = state;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  useEffect(t1, t2);
  if (props.isAdmin) {
    let t3;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <AdminPlaceholder>Placeholder for `Track Order Status` component. <br />The component will display correctly in Consumer</AdminPlaceholder>;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    return t3;
  }
  if (getUserAccessTokenCookie()) {
    let t3;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Redirect to="/customer/orders/" />;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    return t3;
  }
  let t3;
  if ($[16] !== props.client) {
    t3 = async (order_id, zip) => {
      ;
      try {
        let theOrder_id = order_id;
        theOrder_id = parseInt(theOrder_id, 10);
        return await props.client.query({
          query: GET_ORDER_TRACKING_WITH_ZIP,
          variables: {
            theOrder_id,
            zip
          }
        });
      } catch (t4) {
        return null;
      }
    };
    $[16] = props.client;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  const getOrderTrackingWithZipQuery = t3;
  let t4;
  if ($[18] !== setErrMsg) {
    t4 = () => {
      setErrMsg("");
      setIsLoading(false);
    };
    $[18] = setErrMsg;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== getOrderTrackingWithZipQuery || $[21] !== props.history || $[22] !== setErrMsg || $[23] !== setMode) {
    t5 = async t6 => {
      const {
        order_id: order_id_0,
        zip: zip_0
      } = t6;
      setMode("form");
      setErrMsg("");
      setIsLoading(true);
      const queryLookup = await getOrderTrackingWithZipQuery(order_id_0, zip_0);
      if (queryLookup?.loading === false) {
        setIsLoading(false);
        if (queryLookup.data.getOrderTrackingWithZip.errors) {
          setErrMsg("The order number does not match the billing zip code provided. Please double check and try again");
        }
        if (queryLookup.data.getOrderTrackingWithZip.order_id) {
          setErrMsg("");
          props.history.push("/order-tracking/view/", {
            tracking_info: queryLookup.data.getOrderTrackingWithZip
          });
        }
      }
    };
    $[20] = getOrderTrackingWithZipQuery;
    $[21] = props.history;
    $[22] = setErrMsg;
    $[23] = setMode;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== t4 || $[26] !== t5) {
    t6 = {
      resetError: t4,
      formSubmitHandle: t5
    };
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  const actions = t6;
  let t7;
  if ($[28] !== actions || $[29] !== props.location.pathname || $[30] !== state) {
    t7 = <div className="bg-gray-light9 md:px-0 md:py-12">{props.location.pathname === "/order-tracking/view/" && state.tracking_info ? <TrackOrderStatusView state={state} actions={actions} /> : <TrackOrderStatusForm state={state} actions={actions} />}</div>;
    $[28] = actions;
    $[29] = props.location.pathname;
    $[30] = state;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  return t7;
};
TrackOrderStatus.propTypes = {
  isAdmin: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    state: PropTypes.object
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
    replace: PropTypes.func,
    location: PropTypes.node
  }),
  client: PropTypes.shape({
    query: PropTypes.func
  })
};
export default compose(withRouter, withApolloClient)(TrackOrderStatus);